require('lodash')
require('popper.js').default
require('axios')

import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
import VueGtag from 'vue-gtag'
import router from './router'
import store from './store'
import './assets/css/index.css'
import './assets/css/litera_bootstrap.css'
import './assets/promo_ga.js'
import 'bootstrap-icons/font/bootstrap-icons.css'

Vue.use(require('vue-script2'))

// @ts-ignore
Vue.$recurly = Vue.prototype.$recurly = recurly
Vue.config.productionTip = false

Vue.use(Meta, {
  attribute: 'meta',
  ssrAttribute: 'meta-ssr',
  tagIDKeyName: 'meta'
})

Vue.use(VueGtag, {
  config: { id: "G-VMRM8KSY5M" },
  params: {
    send_page_view: false
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
